import React from "react";

export default function linkedin() {
  return (
    <div className="rounded-full shadow-md mx-2 px-3.5 bg-[#222A36] py-3.5 w-12 h-12 justify-center shadow-[#ff3c64] ">
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.2813 0H1.7187C0.7695 0 0 0.7695 0 1.7187V17.2812C0 18.2305 0.7695 19 1.7187 19H17.2812C18.2305 19 19 18.2305 19 17.2812V1.7187C19 0.7695 18.2305 0 17.2813 0ZM5.87941 16.4059C5.87941 16.6821 5.65548 16.906 5.37924 16.906H3.25014C2.9739 16.906 2.74998 16.6821 2.74998 16.4059V7.48078C2.74998 7.20453 2.9739 6.98061 3.25014 6.98061H5.37924C5.65548 6.98061 5.87941 7.20453 5.87941 7.48078V16.4059ZM4.31469 6.13929C3.19762 6.13929 2.29204 5.2337 2.29204 4.11663C2.29204 2.99956 3.19762 2.09398 4.31469 2.09398C5.43176 2.09398 6.33735 2.99956 6.33735 4.11663C6.33735 5.2337 5.43181 6.13929 4.31469 6.13929ZM17.006 16.4461C17.006 16.7001 16.8001 16.906 16.5461 16.906H14.2614C14.0075 16.906 13.8016 16.7001 13.8016 16.4461V12.2598C13.8016 11.6353 13.9847 9.52313 12.1695 9.52313C10.7615 9.52313 10.4759 10.9688 10.4185 11.6176V16.4461C10.4185 16.7001 10.2126 16.906 9.95864 16.906H7.74897C7.495 16.906 7.28909 16.7001 7.28909 16.4461V7.44049C7.28909 7.18653 7.495 6.98061 7.74897 6.98061H9.95864C10.2126 6.98061 10.4185 7.18653 10.4185 7.44049V8.21914C10.9406 7.43562 11.7165 6.83085 13.3686 6.83085C17.0269 6.83085 17.006 10.2487 17.006 12.1266V16.4461Z"
          fill="#FF3C64"
        />
      </svg>
    </div>
  );
}
